import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Spinner } from "../components/states";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function PayReturn() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const pid = params.get("pid") || sessionStorage.getItem("rav3_pending_pid");
  useEffect(() => {
    if (!pid) { setState("missing"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/phonepe/${pid}/status`);
        if (data.status === "paid") { sessionStorage.removeItem("rav3_pending_pid"); await refresh(); setState("paid"); setTimeout(() => nav("/dashboard"), 1500); return; }
        if (data.status === "failed") { setState("failed"); return; }
      } catch { /* keep polling */ }
      if (++tries < 12) setTimeout(poll, 4000); else setState("pending");
    };
    poll();
  }, [pid, nav, refresh]);
  const msg = { checking: "Confirming your PhonePe payment…", paid: "Payment confirmed — thank you!", failed: "Payment failed or was cancelled. Nothing was charged.", pending: "Still pending with PhonePe. We'll unlock access automatically once it completes.", missing: "No payment to verify." }[state];
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <BackButton fallback="/dashboard" className="mb-6" />
      {state === "checking" && <Spinner />}
      <p data-testid="pay-return-status" className={`font-display text-2xl font-bold mt-4 ${state === "paid" ? "text-[#10B981]" : state === "failed" ? "text-[#ef4444]" : ""}`}>{msg}</p>
      {state !== "checking" && <button onClick={() => nav(state === "paid" ? "/dashboard" : "/membership")} className="copper-btn rounded-full px-6 py-2.5 mono-label mt-6">CONTINUE</button>}
    </div>
  );
}
